export default __webpack_public_path__ + "static/media/whyparticipate-girl.91d16f78.svg";